import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const Container = styled('div')`
  display: flex;
`

export const SecondRowContainer = styled(Box)({
    maxWidth: '80vw', // Default width for desktop

    // Center the container on desktop
    margin: '0 auto',
  
    // Media query for screens with a maximum width of 600px (adjust as needed)
    '@media (max-width: 900px)': {
      maxWidth: '100%', // Set width to 100% for smaller screens
    },
  });